export class ApiFehler extends Error {
  readonly status: number;
  readonly code: string;
  readonly details: unknown;

  constructor(status: number, code: string, meldung: string, details?: unknown) {
    super(meldung);
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

/** Meldet „abgemeldet“, sobald der Server 401 antwortet. */
export const sitzungsEreignisse = new EventTarget();

export async function api<T>(pfad: string, optionen: { methode?: string; body?: unknown } = {}): Promise<T> {
  const mitKoerper = optionen.body !== undefined;
  let r: Response;
  try {
    r = await fetch(pfad, {
      method: optionen.methode ?? "GET",
      credentials: "same-origin",
      headers: mitKoerper ? { "content-type": "application/json" } : {},
      body: mitKoerper ? JSON.stringify(optionen.body) : undefined,
    });
  } catch {
    throw new ApiFehler(0, "offline", "Keine Verbindung zum Server.");
  }
  if (r.status === 401) sitzungsEreignisse.dispatchEvent(new Event("abgemeldet"));
  if (!r.ok) {
    const daten = (await r.json().catch(() => ({}))) as { fehler?: string; meldung?: string; details?: unknown };
    throw new ApiFehler(r.status, daten.fehler ?? "unbekannt", daten.meldung ?? "Unbekannter Fehler.", daten.details);
  }
  if (r.status === 204) return undefined as T;
  return (await r.json()) as T;
}
